/** Chamado aberto (link, clique na fila) ainda carregando — ou que não
 * existe / está fora do acesso, com saída para a lista. Sem isto a lista
 * ficava na tela enquanto carrega, e para sempre se o id não existe. */
export function IssueLoadState({ failed, onBack }: { failed: boolean; onBack: () => void }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-4 text-center text-sm text-subtle">
      {failed ? 'Chamado não encontrado ou fora do seu acesso.' : 'Carregando chamado…'}
      {failed && (
        <button
          type="button"
          onClick={onBack}
          className="font-medium text-blue-700 hover:underline dark:text-blue-400"
        >
          Voltar para os chamados
        </button>
      )}
    </div>
  )
}
